




































import Vue, {PropType} from 'vue';
import {AdminMessage} from '#/Conversations';
import {AdminMessageType} from '@/store/modules/Conversations/state';
import {VForm} from '#/index';
import {mapActions} from 'vuex';

interface ComponentData {
  checkboxRules: ((v: boolean | undefined) => boolean | string)[];
  formSubmitted: boolean;
}

export default Vue.extend({
  name: 'AdminDialog',

  props: {
    displayed: {
      required: true,
      type: Boolean as PropType<boolean>,
      default: false,
    },
    message: {
      type: Object as PropType<AdminMessage | null>,
    },
  },

  data: function (): ComponentData {
    return {
      checkboxRules: [
        // @ts-ignore
        (v: boolean | undefined) => !this.formSubmitted || v || this.$t('admin.message.dialog.cguAccepted') as string,
      ],
      formSubmitted: false,
    };
  },

  computed: {
    adminMessageType(): { EULA: number, POPUP: number } {
      return {EULA: AdminMessageType.EULA, POPUP: AdminMessageType.POPUP};
    },
    content(): string | undefined {
      return this.message?.content;
    },
    isEulaMessage(): boolean {
      return this.message?.type === AdminMessageType.EULA;
    },
    isPopMessage(): boolean {
      return this.message?.type === AdminMessageType.POPUP;
    },
    title(): string | undefined {
      return this.message?.title;
    },
  },

  methods: {
    ...mapActions(['sendAcknowledgement']),
    onClose(): void {
      this.$emit('update:displayed', false);
    },
    onSubmit(type: AdminMessageType.EULA | AdminMessageType.POPUP): void {
      const validation = (): void => {
        this.sendAcknowledgement(this.message)
            .then(() => {
              if (!this.message) {
                this.$emit('update:displayed', false);
              }
            });
      };

      if (type === AdminMessageType.EULA) {
        this.formSubmitted = true;
        const form = this.$refs.form as VForm;

        if (form.validate()) {
          validation();
        }
      } else {
        validation();
      }
    },
  },
});
